import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runQueryOnce } from '@/pages/shared/rtk-query-helpers';

/**
 * Both endpoints are GETs on the server, including the rollback itself. That is a server
 * API choice preserved here rather than corrected during a data-layer migration.
 */
export const revisionRollbackApi = createApi({
    reducerPath: 'revisionRollbackApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getDocument: builder.query({
            query: ({ documentNumber, siteId }) => ({
                url: '/api/revisionRollBack/documentFind',
                method: 'GET',
                params: { documentNumber, siteId },
            }),
            keepUnusedDataFor: 0,
        }),
        rollback: builder.query({
            query: ({ documentNumber, siteId }) => ({
                url: '/api/revisionRollBack/rollback',
                method: 'GET',
                params: { documentNumber, siteId },
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

/**
 * Runs a `revisionRollbackApi` query once and releases its cache subscription.
 */
export const runRevisionRollbackQuery = (dispatch, endpointName, arg) =>
    runQueryOnce(dispatch, revisionRollbackApi.endpoints[endpointName], arg);

export default revisionRollbackApi;
